<div class="bmc-working-time-schema">
  <div class="bmc-working-time-schema__top bz-space--stack-l">
    <div class="bz-space--stack-xl">
      <div class="bmc-working-time-schema__top-header">
        <h5 class="bmc-working-time-schema__title">{{'WORKING_TIME_SCHEMA.DESCRIPTION_TITLE' | translate}}</h5>
      </div>
    </div>
    <div class="bmc-working-time-schema__body">
      <working-time-schema-viewer class="bmc-working-time-schema__body--left bz-space--inline-m"></working-time-schema-viewer>
      <working-time-schema-detail class="bmc-working-time-schema__body--right"></working-time-schema-detail>
    </div>
  </div>
  <div class="bmc-working-time-schema__bottom" *ngIf="selectedUser">
    <bzg-tab-set class="bmc-working-time-schema__tabs" (onSelectTab)="selectedTab = $event.index">
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'WORKING_TIME_SCHEMA.ADDITIONAL_NON_WORKING_DAYS' | translate | uppercase}}">
        <working-time-schema-days></working-time-schema-days>
      </bzg-tab-item>
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'WORKING_TIME_SCHEMA.CUSTOM_WORKING_HOURS' | translate | uppercase}}">
        <working-time-schema-hours></working-time-schema-hours>
      </bzg-tab-item>
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 2}" displayName="{{'WORKING_TIME_SCHEMA.MANDATORY_BASE_CALENDAR' | translate | uppercase}}">
        <working-time-schema-calendar></working-time-schema-calendar>
      </bzg-tab-item>
    </bzg-tab-set>
  </div>
  <div class="bmc-working-time-schema__loading-container" *ngIf="(isLoadingBase$ | async) || (isLoadingUserCalendars$ | async)">
    <bzg-loading [size]="'m'" class="bmc-working-time-schema__loading">{{'GLOBAL.LOADING_DATA' | translate}}</bzg-loading>
  </div>
</div>

<div class="bmc-working-time-schema__buttons">
  <bzg-button-secondary class="bz-space--inline-m" [disabled]="!selectedUser" (click)="cancel()">
    {{'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
  <bzg-button-primary (click)="save()" [disabled]="!selectedUser">
    {{'GLOBAL.SAVE' | translate}}
  </bzg-button-primary>
</div>